import axiosInstance from "./mainApi";
import store from "../store/store";
import {
  addMilling,
  addMoreMillings,
  deleteMilling,
  updateMilling
} from "../store/actions/millingStoreFunctions";

// GET ALL
const getAllMillingsApi = async () => {
  try {
    const { data, status } = await axiosInstance.get("/millings");

    if (status === 200) {
      const list = data?.content || data || [];

      const sorted = [...list].sort((a, b) => b.millingId - a.millingId);

      store.dispatch(addMoreMillings(sorted));
      return sorted;
    }

    return data;
  } catch (error) {
    console.error("Error fetching millings:", error);
    throw error;
  }
};

// CREATE
const createMillingApi = (millingData) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post("/millings", millingData);
      dispatch(addMilling(response.data));
      return response.data;
    } catch (error) {
      console.error("Error creating milling:", error);
      throw error;
    }
  };
};

// UPDATE
const updateMillingApi = (id, data) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.put(`/millings/${id}`, data);
      dispatch(updateMilling(response.data));
      return response.data;
    } catch (error) {
      console.error("Error updating milling:", error);
      throw error;
    }
  };
};

// DELETE
const deleteMillingApi = (id) => {
  return async (dispatch) => {
    try {
      await axiosInstance.delete(`/millings/${id}`);
      dispatch(deleteMilling(id));
    } catch (error) {
      console.error("Error deleting milling:", error);
      throw error;
    }
  };
};

const millingApi = {
  getAllMillingsApi,
  createMillingApi,
  updateMillingApi,
  deleteMillingApi
};

export default millingApi;
